import {
  IMediaModel,
  useUserCurrentSubprofileSelector,
  userProfileHelper,
} from "@nf/common";

export const useMediaForKids = (items: IMediaModel[] | undefined) => {
  const currentProfile = useUserCurrentSubprofileSelector();
  if (!items) {
    return undefined;
  }
  if (currentProfile?.Child && currentProfile.ProfileType) {
    const maxRating = userProfileHelper.getMaxAllowedParentalRating(
      currentProfile.ProfileType
    );

    return items.filter((item) => {
      if (!item.MediaAgeRestrictionValueMin) {
        return true;
      }
      return parseInt(item.MediaAgeRestrictionValueMin) <= maxRating;
    });
  }
  return items;
};
